import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const PartialSaleHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/statpic/sales-journey/hos/rle-wizard/icons/16946db3fbbe1bc05ec0f836f47c9728_PartialSaleHighlighter1x.png, ' +
          'https://www.static-immobilienscout24.de/statpic/statpic/sales-journey/hos/rle-wizard/icons/ba43e76fa49931a17ce4e20440262bce_PartialSaleHighlighter2x.png, ' +
          'https://www.static-immobilienscout24.de/statpic/statpic/sales-journey/hos/rle-wizard/icons/2b93d4c033d278a7bfbaf8834a71a86c_PartialSaleHighlighter3x.png'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/statpic/sales-journey/hos/rle-wizard/icons/72c982dcccc840f5c2e936c0378c3fc6_PartialSaleHighlighterIcon.png'
        }
        width={128}
        height={128}
        alt={''}
      />
    </div>
  )
}
